export interface ILoyaltyAvatarListItem {
  id: string;
  avatar: string;
  locked?: boolean;
}

// Loyalty types
export enum LoyaltyStatuses {
  "ACTIVE" = "active",
  "DRAFT" = "draft",
  "DEACTIVE" = "deactive",
  "ARCHIVED" = "archived",
}

export interface CurrencyRewardLoyalty {
  currencyCode: string;
  currencyReward: {
    mascotId?: string;
    rewardFreeSpinId?: string;
    boosterId?: string;
    rollbackTime?: number | undefined;
    timeUntilRollback?: number | undefined;
    timeUntilRollbackCountdown?: number | undefined;
  };
}

export interface LevelRankLoyalty {
  name: string;
  requirement: number;
  rewards: {
    rewardNominalId?: string;
    rewardDepositWeeklyId?: string;
    rewardCashbackDailyId?: string;
    rewardCashbackWeeklyId?: string;
    rewardCashbackMonthlyId?: string;
    currencyRewards: CurrencyRewardLoyalty[];
  };
}

export interface RankLoyalty {
  name: string;
  levelCount: number;
  link: string;
  rewards: {
    rewardNominalId?: string;
    rewardDepositWeeklyId?: string;
    rewardCashbackDailyId?: string;
    rewardCashbackWeeklyId?: string;
    rewardCashbackMonthlyId?: string;
    currencyRewards: CurrencyRewardLoyalty[];
  };
  levels: LevelRankLoyalty[];
}

export interface Loyalty {
  id: string;
  segmentId: string;
  name: string;
  status: LoyaltyStatuses;
  currencies: string[];
  settings: {
    ranks: RankLoyalty[];
  };
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export enum LoyaltyRewardUserStatus {
  Available = "available",
  Assigned = "assigned",
}

export type LoyaltyRewardUser = {
  id: string;
  loyaltyId: string;
  rewardId: string;
  userId: {
    low: number;
    high: number;
    unsigned: boolean;
  };
  currency: string;
  status: LoyaltyRewardUserStatus;
  createdAt: string;
  updatedAt: string;
  rankIndex: number;
  levelIndex?: number;
};

export enum RewardCard {
  EXPERIENCE,
  BONUS,
}

export type LoyaltyRewardCardBase = {
  id: number;
  img: string;
  title: string;
  desc: string;
};

export type LoyaltyGetRewardCardType = LoyaltyRewardCardBase & {
  type: RewardCard;
  buttonText: string;
  url?: string;
};
